import React from 'react';

const Header = (props) => (
  <header style={props.style}>
    {props.children}
  </header>
);

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js